<script setup>
import { useAttrs } from 'vue';

// TUINITY: white-label sidebar / subheader icon — hardcoded (Cloudinary) so it
// always renders regardless of the DB-stored LOGO_THUMBNAIL config, and shows on a
// plain `git pull` without touching /super_admin. The hydra on a celeste circle.
const TUINITY_LOGO =
  'https://res.cloudinary.com/db3espoei/image/upload/v1781633066/hydra_oscuro_ijjvdh.png';

const attrs = useAttrs();
</script>

<template>
  <img v-bind="attrs" :src="TUINITY_LOGO" class="object-contain rounded-full" />
</template>
